import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { euToIso, isoToEu } from "@/lib/dates";

// Text input for DD.MM.YYYY entry. Emits ISO "YYYY-MM-DD" via onChange,
// null while the typed text is incomplete/invalid, "" when cleared.
export function DateInput({ value, onChange, id, testid, placeholder = "DD.MM.YYYY" }) {
  const [text, setText] = useState(isoToEu(value));

  useEffect(() => {
    // Only sync from parent when it provides a definitive ISO date or an
    // explicit empty string. `null` means "partial/invalid typing in progress"
    // and would otherwise wipe the user's in-flight digits.
    if (value === "" || (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value))) {
      setText(isoToEu(value));
    }
  }, [value]);

  const handle = (e) => {
    const raw = e.target.value.replace(/[^\d]/g, "").slice(0, 8);
    let out = raw;
    if (raw.length > 4) out = `${raw.slice(0, 2)}.${raw.slice(2, 4)}.${raw.slice(4)}`;
    else if (raw.length > 2) out = `${raw.slice(0, 2)}.${raw.slice(2)}`;
    setText(out);
    onChange(out === "" ? "" : euToIso(out));
  };

  return (
    <Input
      id={id}
      data-testid={testid}
      value={text}
      onChange={handle}
      placeholder={placeholder}
      inputMode="numeric"
      autoComplete="off"
    />
  );
}
